import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';
import Header from '~/Components/Header';
import './index.css';

const Mapa = () => {
  const openPdfInNewTab = (pdfPath) => {
    const newWindow = window.open(pdfPath, '_blank');
  };
  return (
    <>
      <Header title="Mapa de Salas de Reunião" />
      <Container fluid>
        <Row className='mt-3 justify-content-center'>
          <Col xs={12} lg={6}>
            <div className="mapaPdfSection">
              <h5 className="mapaSectionTitle">Penita - Mapa</h5>
              <div className="mapaIframeContainer">
                <iframe
                  className="mapaIframeResponsive"
                  src="/Documents/PENITA-LAY OUT REUNIÕES-OUT 2025.pdf#toolbar=0"
                  title="R. Penita - Layout de Reuniões"
                ></iframe>
              </div>
              <Button
                variant="primary"
                size="sm"
                className="mt-2 w-100"
                onClick={() =>
                  openPdfInNewTab(
                    '/Documents/PENITA-LAY OUT REUNIÕES-OUT 2025.pdf',
                    'Penita - Layout de Reuniões - Outubro 2025'
                  )
                }
              >
                <FaExternalLinkAlt className="mr-2" />
                Abrir em nova guia
              </Button>
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div className="mapaPdfSection">
              <h5 className="mapaSectionTitle">XV de Novembro - Mapa</h5>
              <div className="mapaIframeContainer">
                <iframe
                  className="mapaIframeResponsive"
                  src="/Documents/XV NOVEMBRO-LAY OUT REUNIÕES-OUT 2025.pdf#toolbar=0"
                  title="R. XV Novembro - Layout de Reuniões"
                ></iframe>
              </div>
              <Button
                variant="primary"
                size="sm"
                className="mt-2 w-100"
                onClick={() =>
                  openPdfInNewTab(
                    '/Documents/XV NOVEMBRO-LAY OUT REUNIÕES-OUT 2025.pdf',
                    'XV Novembro - Layout de Reuniões - Outubro 2025'
                  )
                }
              >
                <FaExternalLinkAlt className="mr-2" />
                Abrir em nova guia
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Mapa;
